import { service } from "./service";

import { config } from "./config";
import { store } from "../../pinia/store";
import { isJSON } from "@/utils/encryptUtils";
import { baseUrl } from "@/config";
import { jsonToUrl, utilGoLogin, utilIsAndroid, utilIsFlutter, utilIsApp } from '@/utils'
import { useCallAppHandle } from "@/hooks/useBridge";
import { encryApiList } from "@/config/axios/encryApiList";
import { useShowToast } from "@/hooks/useVant";
import { encryPublicKey, importKeyFun } from '@/utils/aesCbcUtil'
const { default_headers } = config;

const doAxios = (option: any) => {
  return new Promise(async (resolve, reject) => {
    const storeData = store();
    const { url, method, params, data, headersType, responseType } = option;
    console.log("option", option);
    if (!url.includes('training/registration/infoToPay') && !(utilIsAndroid() && option.url.includes('pay/control/promotionOrder/pay'))) {
      await getAES();
    }
    storeData.isRefreshAppInputToken = false

    service({
      url,
      method,
      params,
      data,
      responseType: responseType,
      silent: option.silent, // 调用方自己处理失败、不弹通用提示（service.ts 响应拦截器读）
      headers: {
        "Content-Type": headersType || default_headers,
        "X-EFRESH-SECRET": storeData.appData.secret,
        "X-EFRESH-SESSION": storeData.appData.session,
        "c-id": storeData.headerInfo["c-id"],
        "c-meta": storeData.headerInfo["c-meta"],
      },
    } as any).then(resolve).catch(reject)
  });
}


const doSendDataToApp = (option: any) => {
  return new Promise((resolve, reject) => {
    const storeData = store()
    const { url, method, params, data, headersType, responseType } = option;
    console.log("option", option);
    const param = {
      url: url,
      params: method == 'post' ? JSON.stringify(data) : JSON.stringify(params),
      methodType: method == 'post' ? 1 : 0,
      needEncryption: encryApiList.includes(url) ? 'YES' : 'NO'
    }
    if (method === 'get') {
      param.url = jsonToUrl(param.url, params)
      param.params = ''
    }


    useCallAppHandle('basicRequestMethod', param, (response) => {
      console.log('原生端请求数据----开始')
      console.log('接口地址:', url)
      console.log('传参:', method == 'post' ? data : params)
      console.log('获取数据:', response)
      let res
      if (utilIsAndroid() || utilIsFlutter()) {
        res = JSON.parse(response);
      } else {
        res = response;
      }
      if (url.includes('training/registration/infoToPay')) {
        console.log('商学院校验接口',response)
        if (res.code === config.token_invalid_code) {
          useShowToast(res.msg);
          console.log("登录失效");
          useCallAppHandle('toLogout')
          return
        }
        resolve(res)
        return
      }
      if (res && res.status) {
        if (res.code === config.result_code) {
          res.data = isJSON(res.data)
            ? JSON.parse(res.data)
            : res.data
        } else {
          console.log("code500", response);
          if (res.code === config.token_invalid_code) {
            console.log("登录失效");
            storeData.isRefreshAppInputToken = false
            utilGoLogin()
          }
          if ([1237, 567, 3002].includes(res.code)) {
            return resolve(res)
          }
          if (option.silent) {
            // 调用方传 silent: true 时自己处理失败、不弹通用提示
          } else if (res.code === config.error_code) {
            console.log("code5000");
            useShowToast(res.msg);
          } else {
            if (!(['/api/v5/document/technician/tec/updateOnOffLine'].includes(url) && res.code === 2014)) {
              useShowToast(res.msg);
            }
          }
          // 加密解密失败
          if (res.code === 523 || res.code === 560) {
            console.log("加密解密失败");
            storeData.keyStr = "";
            storeData.keyInfo = {}
            window.location.reload();
            return;
          }
        }
        console.log('最终数据为：', res)
        resolve(res)
      } else {
        useShowToast(res?.msg || "网络异常", "fail");
        reject(res)
      }
      console.log('原生端请求数据----结束')
    })
  })
}

const request = (option: any) => {
  if (option.useAxios) {
    return doAxios(option)
  }
  if (utilIsApp() && !option.url.includes('training/registration/infoToPay') && !(utilIsAndroid() && option.url.includes('pay/control/promotionOrder/pay'))) {
    return doSendDataToApp(option)
  } else {
    return doAxios(option)
  }
};

//获取对称密钥API
export const getAES = (isinit = false) => {
  const storeData = store();
  return new Promise(async (resolve) => {
    if ((!storeData.keyInfo && !isinit) || isinit) {
      let url = `${baseUrl}api/v5/secret/aesKey`;
      const res = await service.get(
        url,
        {
          verNum: 1,
          os: storeData.appData.user.os || "104006",
          encryptPublicKey: await encryPublicKey(),
          // encryptPublicKey: $rsaEncrypt(),
          headers: {
            "c-id": storeData.headerInfo["c-id"],
            "c-meta": storeData.headerInfo["c-meta"],
          },
        }
      );
      console.log("获取到的对称密钥", res);
      let uncrypted = res.data;
      // storeData.keyStr = AesEncrypt(uncrypted);
      const ikey = await importKeyFun(uncrypted)
      storeData.keyInfo = ikey;
      resolve(storeData.keyInfo);
      // resolve(storeData.keyStr);
    } else {
      console.log("无需重新获取或者此接口无需加密");
      resolve(storeData.keyInfo);
      // resolve(storeData.keyStr);
    }
  });
};

export default {
  get: <T = any>(option: any) => {
    if (option.url === '/api/v4/help/docs') {
      for (let key in option?.params) {
        if (!option.params[key]) {
          delete option.params[key]
        }
      }
    }
    return request({ method: "get", ...option }) as unknown as T;
  },
  post: <T = any>(option: any) => {
    return request({ method: "post", ...option }) as unknown as T;
  },
  delete: <T = any>(option: any) => {
    return request({ method: "delete", ...option }) as unknown as T;
  },
  put: <T = any>(option: any) => {
    return request({ method: "put", ...option }) as unknown as T;
  },
};
